import script from "./ConfirmYourLoanDetailsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmYourLoanDetailsModal.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmYourLoanDetailsModal.vue?vue&type=style&index=0&id=22ec18c6&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22ec18c6"]])

export default __exports__